import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text,
} from "@chakra-ui/core";
import { FiLogOut } from "react-icons/fi";
// import { useIdentityContext } from "react-netlify-identity";
import { Redirect } from "react-router-dom";
import { logoutUser } from "../../utils/auth";

/** Open the profile menu from the avatar icon, f
 * for now only logout is available
 */

const ProfileMenu = ({merchantDetails}) => {
  const [redirect, setRedirect] = useState(false);

  if (redirect) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <Menu autoSelect={false}>
        <MenuButton
          variant="ghost"
          as={Button}
          _hover={{ bg: "none" }}
          size="xs"
        >
          <Avatar
            borderWidth="1px"
            bg="primary.500"
            size="xs"
            name={`${merchantDetails.firstName} ${merchantDetails.lastName}`}
          />
        </MenuButton>
        <MenuList placement="bottom-end">
          <MenuItem
            onClick={(e) => {
              logoutUser(e);
              setRedirect(true);
            }}
          >
            <Box color="primary.500" mx="8px" as={FiLogOut} size="16px" />
            <Text>Logout</Text>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};

export default ProfileMenu;
